import axios from 'axios';

const create_or_select_unit_group = function () {
  let baseUnit = $('#measurement_unit_base_unit').is(':checked');
  $('.unit-group-field').toggleClass('d-none', !baseUnit);
  $('.unit-group-select').toggleClass('d-none', baseUnit);
  $('.conversion-table').toggleClass('d-none', baseUnit);
  if ($('#measurement_unit_measurement_unit_group_id').val() !== '') {
    $('.conversion-table').toggleClass('d-none', baseUnit);
  }
};

const show_conversion_table = function () {
  let groupId = $('#measurement_unit_measurement_unit_group_id').val();
  let url = '/measurement_unit_groups/' + groupId + '/base_unit.json';
  axios
    .get(url)
    .then((response) => {
      $('.base_unit_id').val(response.data.id);
      $('.base_unit_name').html(response.data.name);
      $('.conversion-table').toggleClass('d-none', false);
    })
    .catch((error) => {
      console.log(error.response.data);
    });
};

const fill_alt_unit = function () {
  let altUnitName = $('#measurement_unit_name').val();
  $('.alt_unit_name').html(altUnitName);
};

const clear_measurement_unit_group_hidden_field = function () {
  if ($('#measurement_unit_base_unit').is(':checked')) {
    $('#measurement_unit_measurement_unit_group_id').val('');
    $('#conversion_factor_edit_table :input').val('');
  } else {
    $('#measurement_unit_measurement_unit_group_attributes_name').val('');
  }
};

document.addEventListener('turbolinks:load', function () {
  create_or_select_unit_group();
  $('#measurement_unit_base_unit').on('change', create_or_select_unit_group);
  $('#measurement_unit_measurement_unit_group_id').on(
    'change',
    show_conversion_table
  );
  $('#measurement_unit_name').on('keyup', fill_alt_unit);
  $('#measurement_unit_name').on('change', fill_alt_unit);
  $('.new_measurement_unit').on(
    'submit',
    clear_measurement_unit_group_hidden_field
  );
  $('.edit_measurement_unit').on(
    'submit',
    clear_measurement_unit_group_hidden_field
  );
});
